import { gql } from "graphql-tag";

// libs/ui is shared by every app, so it cannot import documents from a
// per-app folder (packages/<app>/src/graphql).
// These two documents are owned by the component that runs them; only the
// generated schema types come from @onmo/graphql/graphql.
export const loginRewardsGQL = gql`
  query {
    loginRewards {
      ... on CoinLoginReward {
        __typename
        amount
        claimStatus
        walletType
        itemType
      }
      ... on AchievementLoginReward {
        __typename
        amount
        walletType
        claimStatus
        achievementType: itemType
      }
    }
  }
`;

export const claimLoginRewardGQL = gql`
  mutation Mutation($day: Int!) {
    claimLoginReward(day: $day) {
      message
    }
  }
`;

// Refetched by operation name rather than by document: each app owns its own
// copy of the MeProfile query, so only the name is stable across apps.
export const ME_PROFILE_QUERY_NAME = "MeProfile";
